import { LostStrandType } from "@/pages/caster/models/caster.models";
import { getLostStrandTypes } from "@/pages/caster/repositories/ProductionRepository";
import { useStyles } from "@/pages/eaf/data-entry/styles/useDEStyles";
import { ErrorModal } from "@dexteel/mesf-core";
import {
	FormControl,
	FormHelperText,
	InputLabel,
	MenuItem,
	Select,
} from "@mui/material";
import { get } from "lodash-es";
import { useEffect, useRef, useState } from "react";

export const LostStrandTypeSelector = ({
	value,
	onChange,
	disabled,
	error,
	helperText,
}: {
	value: number | null;
	onChange: (value: number) => void;
	disabled: boolean;
	error?: string;
	helperText?: string;
}) => {
	const isFirstRender = useRef(true);
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [fetchError, setFetchError] = useState<string>("");
	const [options, setOptions] = useState<LostStrandType[]>([]);
	const [lostStrandType, setLostStrandType] = useState<number>();
	const classes = useStyles();

	const loadData = async () => {
		setIsLoading(true);
		const resp = await getLostStrandTypes();
		if (resp.ok) {
			const lostStrandTypes = get(resp, "data.tables[0].rows", []);
			setOptions(lostStrandTypes);
		} else {
			setFetchError(resp.message!);
		}
		setIsLoading(false);
	};

	useEffect(() => {
		if (isFirstRender.current) {
			isFirstRender.current = false;
			loadData().then(() => {});
			return;
		}
	}, []);

	return (
		<>
			<FormControl variant="outlined" fullWidth>
				<InputLabel id="lostStrandTypeSelector" className={classes.inputLabel}>
					Lost Strand Type
				</InputLabel>
				<Select
					fullWidth
					disabled={isLoading || disabled}
					labelId="lostStrandTypeSelector"
					id="lostStrandTypeSelector"
					value={value || ""}
					error={!!error}
					onChange={(event) => {
						const selectedValue = event.target.value as number;
						onChange(selectedValue);
						setLostStrandType(selectedValue);
					}}
					label="Lost Strand Type"
				>
					{options.map((option) => (
						<MenuItem
							key={`lost-strand-type-${option.LostStrandTypeId}`}
							value={option.LostStrandTypeId}
						>
							{option.Description}
						</MenuItem>
					))}
				</Select>
				{error && <FormHelperText error>{error}</FormHelperText>}
			</FormControl>
			<ErrorModal error={fetchError} onHide={() => setFetchError("")} />
		</>
	);
};
